import { useEffect } from 'react'
import { trpc } from '../api/index.js'
import { applyBrandColor } from '../lib/theme.js'

function setFavicon(src: string) {
  let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']")
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.href = src
}

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const q = trpc.setari.getAspect.useQuery(undefined, { staleTime: Infinity, retry: false })

  useEffect(() => {
    if (!q.data) return
    if (q.data.temaVizuala?.brandColor) applyBrandColor(q.data.temaVizuala.brandColor)
    const logo = q.data.logoBase64 ?? '/favicon.svg'
    setFavicon(logo)
    try {
      if (q.data.logoBase64) localStorage.setItem('edrikom_logo', q.data.logoBase64)
      else localStorage.removeItem('edrikom_logo')
    } catch {}
  }, [q.data])

  return <>{children}</>
}
